import { gql, useMutation } from '@apollo/client';
import { EMPLOYEE_FIELDS, Employee } from '@dieterApi/user/useUserQuery';

const DELETE_EMPLOYEE = gql`
  ${EMPLOYEE_FIELDS}
  mutation deleteEmployee($employeeId: String!) {
    deleteEmployee(employeeId: $employeeId) {
      ...UserEmployeeFields
    }
  }
`;

export interface DeleteEmployeeResult {
  deleteEmployee: Employee;
}

export interface DeleteEmployeeInput {
  employeeId: string;
}

export interface DeleteEmployeeContext {
  companyId: string;
}

export function useEmployeeDeleteMutation() {
  return useMutation<DeleteEmployeeResult, DeleteEmployeeInput, DeleteEmployeeContext>(DELETE_EMPLOYEE, {
    update: (cache, { data }, options) => {
      if (!data?.deleteEmployee) {
        return;
      }

      const companyId = options.context?.companyId;
      if (!companyId) {
        return;
      }

      const cacheId = `Company:${companyId}`;
      const deletedEmployeeId = data.deleteEmployee.id;

      cache.modify({
        id: cacheId,
        fields: {
          employees(existingEmployees = [], { readField }) {
            return existingEmployees.filter((employeeRef: any) => readField('id', employeeRef) !== deletedEmployeeId);
          },
        },
      });

      // Evict the deleted employee from cache
      cache.evict({ id: `Employee:${deletedEmployeeId}` });
      cache.gc();
    },
  });
}
